"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_chunk_1 = __importDefault(require("lodash.chunk"));
var FetchError_1 = require("../FetchError");
var utils_1 = require("../utils");
var TweekClient = (function () {
    function TweekClient(config, useLegacyEndpoint) {
        this._contextToQueryParams = function (context) {
            if (!context) {
                return {};
            }
            return Object.keys(context).reduce(function (pre, cur) {
                var identityContext = context[cur];
                if (typeof identityContext === 'string') {
                    identityContext = { id: identityContext };
                }
                Object.entries(identityContext).forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return (pre[key === 'id' ? cur : cur + "." + key] = value);
                });
                return pre;
            }, {});
        };
        this.config = __assign({ context: {} }, config);
        this.config.baseServiceUrl = utils_1.normalizeBaseUrl(config.baseServiceUrl);
        this._endpoint = useLegacyEndpoint ? '/api/v1/keys/' : '/api/v2/values/';
    }
    TweekClient.prototype.getValues = function (path, config) {
        return this._splitToChunks(path, config, false).then(function (res) { return res.data; });
    };
    TweekClient.prototype.getValuesWithDetails = function (path, config) {
        return this._splitToChunks(path, config, true);
    };
    TweekClient.prototype.fetch = function (path, config) {
        return this.getValues(path, config);
    };
    TweekClient.prototype._splitToChunks = function (path, _config, includeErrors) {
        var _this = this;
        if (_config === void 0) { _config = {}; }
        var cfg = __assign(__assign({}, this.config), _config);
        var include = cfg.include, _a = cfg.maxChunkSize, maxChunkSize = _a === void 0 ? 100 : _a;
        if (!include) {
            return this._fetchChunk(path, cfg, includeErrors);
        }
        var optimizedInclude = utils_1.optimizeInclude(include);
        var includeChunks = lodash_chunk_1.default(optimizedInclude, maxChunkSize);
        var fetchConfigChunks = includeChunks.map(function (ic) { return (__assign(__assign({}, cfg), { include: ic })); });
        var fetchPromises = fetchConfigChunks.map(function (cc) { return _this._fetchChunk(path, cc, includeErrors); });
        return Promise.all(fetchPromises).then(function (chunks) {
            return chunks.reduce(function (res, ch) { return ({
                data: __assign(__assign({}, res.data), ch.data),
                errors: __assign(__assign({}, res.errors), ch.errors),
            }); });
        });
    };
    TweekClient.prototype._fetchChunk = function (path, _config, includeErrors) {
        var flatten = _config.flatten, baseServiceUrl = _config.baseServiceUrl, context = _config.context, include = _config.include, ignoreKeyTypes = _config.ignoreKeyTypes;
        var queryParamsObject = this._contextToQueryParams(context);
        if (includeErrors) {
            queryParamsObject['$includeErrors'] = true;
        }
        if (flatten) {
            queryParamsObject['$flatten'] = true;
        }
        if (ignoreKeyTypes) {
            queryParamsObject['$ignoreKeyTypes'] = true;
        }
        queryParamsObject['$include'] = include;
        var queryString = utils_1.toQueryString(queryParamsObject);
        var url = "" + baseServiceUrl + this._endpoint + utils_1.normalizeKeyPath(path) + queryString;
        return this.config.fetch(url).then(function (response) {
            if (response.ok) {
                var result = response.json();
                if (includeErrors) {
                    return result;
                }
                return result.then(function (data) { return ({ data: data }); });
            }
            else {
                return Promise.reject(new FetchError_1.FetchError(response, 'Error getting values from tweek'));
            }
        });
    };
    __decorate([
        utils_1.deprecated('getValues')
    ], TweekClient.prototype, "fetch", null);
    return TweekClient;
}());
exports.default = TweekClient;
//# sourceMappingURL=TweekClient.js.map


// WEBPACK FOOTER //
// ../../src/TweekClient/TweekClient.ts